import request from '@/utils/request'
import baseUrl from './baseUrl'

export default { 
	login( username , password ) {
		return request({
	    url: baseUrl + '/auth/login',
	    method: 'post',
	    data: {
	      username,
	      password
	    }
	  })
	},
	getUserInfo(auth){
		return request({
			url: baseUrl + '/auth/admin',
			method: 'get'
		})
	}
}